import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import OrderTitle from "@widgets/pos/orders/details/order/overview/header/OrderTitle";
import OrderFulfillment from "@widgets/pos/orders/details/order/overview/header/OrderFulfillment";

type Props = {
    order: PlacedOrderOverview,
};

const OrderHeader = ({order}: Props) => {
    return (
        <div className={"w-full flex flex-row items-start justify-between gap-6"}>
            <OrderTitle order={order}/>
            <OrderFulfillment order={order}/>
        </div>
    );
};

export default OrderHeader;